import api from 'config/axios';
import downloadRedirect from 'download-redirect';
import AppService from 'common/app-service';
import {
  ICalcSecondaryOperationValueParams,
  ICounterparty,
  ICreateSecondaryOperation,
  ISecondaryOperation,
  ISecondaryOperationDetails,
} from 'common/secondary-operation.interface';
import { DownloadType } from 'common/secondary-operation.type';
import { camelToSnakeCase } from 'utils/api';

export default class SecondaryOperationService extends AppService {
  constructor() {
    super('secondary-operation', api);
  }

  async getActiveCounterparties(): Promise<ICounterparty[]> {
    const response = await this.api.get(this.root('active/counterparties'));
    return response.data;
  }

  async create(secondaryOperationData: ICreateSecondaryOperation): Promise<ISecondaryOperation> {
    const { operationDate, operationCtes, ...restArgs } = secondaryOperationData;
    const requestBody = {
      ...restArgs,
      operationCtes: operationCtes.map((opInfo) =>
        camelToSnakeCase({
          ...opInfo,
        })
      ),
      operationDate: operationDate.toFormat('yyyy-MM-dd'),
    };

    const response = await this.api.post(this.root(), requestBody);
    return response.data;
  }

  async calculateOperationValue(operationData: ICalcSecondaryOperationValueParams) {
    const response = await this.api.post(this.root('calculated-operation-value'), {
      ...operationData,
      operationDate: operationData.operationDate.toFormat('yyyy-MM-dd'),
    });

    return response.data;
  }

  async getOperationData(id: number): Promise<ISecondaryOperationDetails> {
    const response = await this.api.get(this.root(id));

    return response.data;
  }

  async getOperationDownloadResponse(id: number | string, downloadType: DownloadType) {
    return this.api.get(this.root(`${id}/download`), { params: { request_file: downloadType } });
  }

  async getOperationDownloadURL(id: number | string, downloadType: DownloadType) {
    const response = await this.getOperationDownloadResponse(id, downloadType);
    downloadRedirect(response.data.url, response.data.filename);
  }
}
